<template>
    <section class="p-2">
      <v-card class="">
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Master Data Mapping</div>
          <div>
            <bread-crumb :bread-crumbs="['Master Data Mapping']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
  
        <v-tabs v-model="usertype">
          <v-tab
            v-for="item in items"
            :key="item.key"
            :href="'#' + item.key"
            class="text-capitalize text-decoration-none"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="usertype">
          <v-tab-item id="master"> <MasterBankSummary /> </v-tab-item>
          <v-tab-item id="partner"> <MasterBankPartnerMap /> </v-tab-item>
        </v-tabs-items>
      </v-card>
    </section>
  </template>
  
  <script>
  import MasterBankPartnerMap from "./MasterBankPartnerMap";
  import MasterBankSummary from "./MasterBankSummary";
  import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
  export default {
    name: "Master Bank Summary",
    data: () => {
      return {
        usertype: "Induvisual",
        items: [
          { label: "Master Bank/Branch summary", key: "master" },
          { label: "Master Bank Mapping", key: "partner" },
        ],
      };
    },
    components: {
      BreadCrumb,
      MasterBankPartnerMap,
      MasterBankSummary,
    },
  };
  </script>
  <style scoped lang="scss">
  @import "@/global.scss";
  </style>
  